export enum CorrectionsAuditorQueryParamsUrlEnum {
  correctionRequestInstId = 'correctionRequestInstId',
  proNbr = 'proNbr',
  queueName = 'queueName',
  requestId = 'requestId',
  status = 'status',
}
